const FAQS = [
  {
    question: 'Apa itu Gerakan Numerasi Nasional (GNN)?',
    answer:
      'Gerakan Numerasi Nasional adalah program kolaboratif antar pemerintah, masyarakat, sekolah, dan lembaga untuk meningkatkan kecakapan numerasi masyarakat Indonesia, sehingga mampu memecahkan masalah dan mengambil keputusan berbasis angka dalam kehidupan sehari-hari.',
  },
  {
    question: 'Mengapa numerasi penting bagi masyarakat Indonesia?',
    answer:
      'Numerasi adalah kemampuan dasar yang diperlukan untuk memahami data, menghitung kebutuhan pokok, mengelola keuangan, dan membuat keputusan rasional, yang semuanya sangat penting untuk keberhasilan dan kesejahteraan individu maupun masyarakat.',
  },
  {
    question: 'Siapa saja yang menjadi sasaran utama GNN?',
    answer:
      'Sasaran utama GNN meliputi siswa, guru, orang tua, masyarakat umum, komunitas, serta pihak swasta dan pemerintah yang terlibat dalam kegiatan dan pengembangan kemampuan numerasi.',
  },
  {
    question: 'Bagaimana cara masyarakat dapat berpartisipasi dalam GNN?',
    answer:
      'Masyarakat dapat berpartisipasi melalui mengikuti pelatihan numerasi, memanfaatkan bahan bacaan dan permainan berbasis numerasi di fasilitas umum, serta aktif dalam kegiatan sosial dan edukatif yang mendukung pengembangan numerasi.',
  },
  {
    question: 'Apa itu Bincang Numerasi?',
    answer:
      'Bincang Numerasi adalah kegiatan berbincang santai antara orang tua atau anggota keluarga dengan anak untuk menumbuhkan kecakapan dan budaya numerasi melalui diskusi mengenai topik yang relevan dalam kehidupan sehari-hari.',
  },
  {
    question:
      'Apa yang menjadi fokus dalam penguatan ekosistem pembelajaran untuk mendukung PM?',
    answer:
      'Fokusnya adalah penguatan peran guru, kepala sekolah, dan pengawas, serta pembangunan ekosistem yang kolaboratif dan berbasis teknologi digital, agar proses pembelajaran mendalam dapat berjalan efektif dan merata di seluruh Indonesia.',
  },
  {
    question: 'Berapa lama durasi ideal untuk melakukan Bincang Numerasi?',
    answer:
      'Durasi sekitar 10 menit per sesi sudah cukup, tetapi jika anak lebih lama masalah selama tidak mengganggu kegiatan belajar-mengajar dan tetap menyenangkan bagi anak.',
  },
  {
    question:
      'Apakah diperlukan alat peraga matematika untuk Bincang Numerasi?',
    answer:
      'Tidak selalu. Bahan di sekitar rumah seperti label kemasan, peralatan dapur, mainan balok, dan benda lain dapat digunakan sebagai media konkret dalam diskusi numerasi.',
  },
  {
    question: 'Seberapa sering Bincang Numerasi sebaiknya dilakukan?',
    answer:
      'Disarankan melakukan kegiatan ini setiap hari agar terbentuk kebiasaan dan budaya numerasi. Rutinitas harian lebih efektif dibandingkan seminggu sekali dengan waktu yang lebih lama.',
  },
  {
    question: 'Bisakah Bincang Numerasi dilakukan dalam bahasa Ibu?',
    answer:
      'Tentu. Bincang Numerasi dilakukan secara natural dan harus sesuai dengan bahasa yang nyaman digunakan anak agar mudah memahami dan terlibat dalam percakapan.',
  },
  {
    question:
      'Bagaimana cara memulai Bincang Numerasi yang menyenangkan dan tidak membosankan?',
    answer:
      'Pilih topik yang menarik, gunakan media sederhana dari lingkungan sekitar, buat suasana santai dan joyful, serta berikan pertanyaan terbuka yang merangsang anak berpikir dan berinteraksi aktif.',
  },
  {
    question: 'Apa itu Taman Numerasi?',
    answer:
      'Taman Numerasi adalah area belajar numerasi yang dirancang untuk memperkenalkan dan menguatkan konsep-konsep numerasi melalui aktivitas bermain, eksplorasi, dan pengalaman konkret yang menyenangkan dan interaktif.',
  },
  {
    question: 'Apa tujuan utama dari pembangunan Taman Numerasi?',
    answer:
      'Tujuan utamanya adalah menumbuhkan minat dan keterampilan numerasi anak secara alami dan menyenangkan, serta menghubungkan pembelajaran numerasi dengan kehidupan sehari-hari dan lingkungan sekitar mereka.',
  },
  {
    question: 'Bagaimana konsep pembelajaran di Taman Numerasi?',
    answer:
      'Pembelajaran dilakukan melalui aktivitas bermain dan eksplorasi yang bersifat kontekstual, interaktif, serta kolaboratif, sehingga anak bisa belajar konsep numerasi secara menyenangkan dan bermakna.',
  },
  {
    question: 'Seperti apa prinsip dalam mendesain Taman Numerasi?',
    answer:
      'Prinsip utamanya adalah menggunakan konsep dasar yang mudah dipahami, seperti pengenalan angka, pengukuran, bentuk, pola, data dan ketidakpastian, serta memastikan lingkungan yang mendukung aktivitas belajar numerasi yang menyenangkan dan aman.',
  },
  {
    question: 'Apa saja aktivitas numerasi yang bisa dilakukan di taman ini?',
    answer:
      'Aktivitas meliputi bermain bilangan, pengenalan konsep pengukuran, bentuk geometri, pola, data dan ketidakpastian, serta pengenalan konsep angka dan keterampilan dasar matematika lainnya.',
  },
  {
    question:
      'Bagaimana kolaborasi antar berbagai pihak dalam pengembangan Taman Numerasi?',
    answer:
      'Kolaborasi dilakukan antara pemerintah daerah, swasta, lembaga pendidikan, komunitas literasi, tokoh masyarakat, dan pihak lain untuk menyediakan fasilitas, mendukung kegiatan, dan mengembangkan inovasi program yang berkelanjutan.',
  },
]

export default FAQS
